'use strict';

import React, {useState, useMemo} from 'react';
import {apiCall} from "../../shared/api-client";

import {formatNumber, formatTotalMinutes, formatSessionLength} from "./shared";
import {MetricsTableColumns, MetricsTableTR} from "./metrics-table";
import {useDashboardFilter, useStaleDataLoader, isStale} from "./state";

const APIMethod = 'dashboard/metrics';
const MetricsTableRows = [
	['Minutes used', 'total', formatTotalMinutes],
	['Active streams (per hour)', 'count', formatNumber],
	['Average session length (minutes)', 'mean', formatSessionLength],
	['Max CCU (per hour)', 'ccu', formatNumber]
];

function BasicMetrics() {
	const [filter] = useDashboardFilter();
	const [data, setData] = useState(null);
	const load = useMemo(() => {
		return async (cancelled) => {
			let f = filter.toJS();
			let response = await apiCall({method: APIMethod, params: f});
			let data = response.data;
			if (cancelled.current) {
				return;
			}
			setData(data);
			return isStale(data);
		}
	}, [filter, setData]);

	useStaleDataLoader(load);

	if (data === null) {
		return 'Loading dashboard data';
	}

	return (
		<section id="dashboard-metrics">
			<h2>Basic metrics</h2>
			<table className="basic-metrics metrics-table cm-table table table-stripped">
				<thead>
					<tr>
						<th>Metric</th>
						<th/>
						{MetricsTableColumns.map(([t, k]) => <th key={k}>{t}</th>)}
					</tr>
				</thead>
				<tbody>
					{MetricsTableRows.map((row, i) => <MetricsTableTR key={`mt-row-${i}`} data={data} row={row}/>)}
				</tbody>
			</table>
		</section>
	);

}

export default BasicMetrics;